// 승객앱 홈 지도 — 운행 중 확대 수준 (2026-10-22 way 실주행).
// «운행 중에는 버스 위치 중심으로 확대돼 보이면 좋겠다 · 늘 전체 노선이 보여 손가락으로 확대한다».
// 예전엔 레벨 9(노선 전체) 고정이었다. 버스가 보이면 버스를 가운데 두고, 내 정류장이 있으면
// 그 정류장까지 한 화면에 들어오는 가장 가까운 레벨을 고른다.
// 순수 모듈 — Firebase·React import 금지.

export const BUS_FOCUS_LEVEL = 5;   // 내 정류장이 없을 때(대략 반경 1km)
export const BUS_FOCUS_MIN = 4;     // 이보다 가까우면 주변 도로가 안 보인다
export const BUS_FOCUS_MAX = 7;     // 이보다 멀면 다시 «전체 노선» 이 된다

function distM(a, b) {
  const R = 6371000, r = Math.PI / 180;
  const x = Math.sin((b.lat - a.lat) * r / 2) ** 2
    + Math.cos(a.lat * r) * Math.cos(b.lat * r) * Math.sin((b.lng - a.lng) * r / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(x));
}
const okLL = (p) => !!p && Number.isFinite(Number(p.lat)) && Number.isFinite(Number(p.lng))
  && !(Number(p.lat) === 0 && Number(p.lng) === 0);

/**
 * 버스를 가운데 둔 채 내 정류장까지 들어오는 레벨.
 * 카카오 레벨 3 ≈ 1m/px, 한 단계마다 2배(근사). 버스가 가운데라 정류장은 중심에서 d 만큼
 * 떨어져 있으므로 화면 짧은 변의 42% 안에 들어오게 잡는다.
 * @returns {number|null} 버스가 없으면 null(=레벨을 건드리지 않는다)
 */
export function busFocusLevel({ bus, stop, widthPx, heightPx } = {}) {
  if (!okLL(bus)) return null;
  if (!okLL(stop)) return BUS_FOCUS_LEVEL;
  const d = distM({ lat: +bus.lat, lng: +bus.lng }, { lat: +stop.lat, lng: +stop.lng });
  const w = Number(widthPx) > 0 ? Number(widthPx) : 360;
  const h = Number(heightPx) > 0 ? Number(heightPx) : 300;
  const px = 0.42 * Math.min(w, h);
  const mpp = d / px;
  const L = mpp <= 0 ? BUS_FOCUS_MIN : 3 + Math.ceil(Math.log2(mpp));
  return Math.max(BUS_FOCUS_MIN, Math.min(BUS_FOCUS_MAX, L));
}

/** 손으로 지도를 옮긴 뒤 자동 추적을 다시 켜기까지(ms). */
export const FOLLOW_HOLD_MS = 20000;
